module.exports = "<div>\n    <p>{{ title }}</p>\n    <span>{{ text }} </span>\n</div>"